import React from 'react';
import {
  FEATURE_AUDIO_FADE_CONTROL,
  FEATURE_PLAYBACKRATE_CONTROL,
  FEATURE_VOLUME_CONTROL,
} from '../flags';
import { AudioItem } from '../items/audio/audio-item-type';
import { AccordionHeader } from '@crabs-ai/ds-react';
import { AudioFadeControls } from './controls/audio-fade-controls';
import { PlaybackRateControls } from './controls/playback-rate-controls';
import { VolumeControls } from './controls/volume-controls';
import { useTranslations } from 'next-intl';
import { useInspectorSections } from './use-inspector-sections';
import { CollapsibleContent } from './collapsible-content';

const AUDIO_DEFAULTS = { volume: true, fade: true, playbackSpeed: true };

const AudioInspectorUnmemoized: React.FC<{
  item: AudioItem;
  isMulti?: boolean;
  collapseAllTrigger?: number;
  expandAllTrigger?: number;
}> = ({ item, collapseAllTrigger = 0, expandAllTrigger = 0 }) => {
  const t = useTranslations();
  const { openSections, toggleSection } = useInspectorSections({
    itemId: item.id,
    defaults: AUDIO_DEFAULTS,
    collapseAllTrigger,
    expandAllTrigger,
  });

  return (
    <div className="layout-padding-bottom">
      <div className="flex flex-col gap-2xs">
        {/* {FEATURE_SOURCE_CONTROL && !isMulti && <SourceControls item={item} />} */}
        {FEATURE_VOLUME_CONTROL && (
          <div className="border-b border-sys-style-neutral-light px-4xs pb-2xs">
            <AccordionHeader
              size="sm"
              title={t('Editor.inspector.volume-control')}
              isOpened={openSections.volume}
              onClick={() => toggleSection('volume')}
            />
            <CollapsibleContent isOpen={openSections.volume}>
              <div className="px-md py-4xs">
                <VolumeControls
                  decibelAdjustment={item.decibelAdjustment}
                  itemId={item.id}
                />
              </div>
            </CollapsibleContent>
          </div>
        )}
        {FEATURE_AUDIO_FADE_CONTROL && (
          <div className="border-b border-sys-style-neutral-light px-4xs pb-2xs">
            <AccordionHeader
              size="sm"
              title={t('Editor.inspector.fade-effect')}
              isOpened={openSections.fade}
              onClick={() => toggleSection('fade')}
            />
            <CollapsibleContent isOpen={openSections.fade}>
              <div className="px-md py-4xs">
                <AudioFadeControls
                  fadeInDuration={item.audioFadeInDurationInSeconds}
                  fadeOutDuration={item.audioFadeOutDurationInSeconds}
                  itemId={item.id}
                  durationInFrames={item.durationInFrames}
                />
              </div>
            </CollapsibleContent>
          </div>
        )}
        {FEATURE_PLAYBACKRATE_CONTROL && (
          <div className="border-b border-sys-style-neutral-light px-4xs pb-2xs">
            <AccordionHeader
              size="sm"
              title={t('Editor.inspector.playback-speed')}
              isOpened={openSections.playbackSpeed}
              onClick={() => toggleSection('playbackSpeed')}
            />
            <CollapsibleContent isOpen={openSections.playbackSpeed}>
              <div className="px-md py-4xs">
                <PlaybackRateControls
                  playbackRate={item.playbackRate}
                  itemId={item.id}
                />
              </div>
            </CollapsibleContent>
          </div>
        )}
      </div>
      {/* 오디오 생성하는 부분 같은데 나중에 쓸일 있을 것 같기도 */}
      {/*<GenerateCaptionSection item={item} />*/}
    </div>
  );
};

export const AudioInspector = React.memo(AudioInspectorUnmemoized);
